/*
 * @Author: your name
 * @Date: 2020-07-30 15:32:11
 * @LastEditTime: 2020-08-03 11:25:41
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-widget-table.config.js
 */
const FormWidgetTableConfig = {
  // 类型
  componentType: 'FORM_WIDGET_TABLE',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-table',
    text: '表格',
    optionTitle: false,
    description: '用于填写多条结构类似的数据'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 3,
    noBorder: true,
    render: {
      edit: 'FormWidgetTable',
      read: 'FormWidgetTable'
    },
    label: '表格',
    children: []
  },
  methods: {},
  editorConfig: ['INFO', 'LABEL', 'HIDDEN', 'READONLY', 'REQUIRED', 'EDITONNEW']
}

export default FormWidgetTableConfig
